/* tslint:disable */
export class ExceptionResponseObject {
    id: number;
    url: string;
    created_at: string;
    exception_image: string;
    exception_context: object;

}
